import React from 'react'
import HomeContainer from './HomeContainer'

const Home = () => <HomeContainer />
export default Home
